import { Component, input } from '@angular/core';
import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';

@Component({
  selector: 'mobi-rating-counter',
  imports: [MobiUiIconComponent],
  templateUrl: './rating-counter.component.html',
  styleUrl: './rating-counter.component.scss',
})
export class RatingCounterComponent {
  readonly count = input(0);
}
